var _circle, _circle2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHostIndicator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "url(#a)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 7.5,
    fill: "url(#b)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.502 6.146a.344.344 0 0 0-.31.19l-1.18 2.362-2.804.431a.344.344 0 0 0-.19.583l1.939 1.94-.432 2.806a.344.344 0 0 0 .499.357l2.476-1.292 2.477 1.292a.343.343 0 0 0 .498-.357l-.432-2.807 1.94-1.94a.345.345 0 0 0-.19-.582l-2.804-.431-1.181-2.362a.344.344 0 0 0-.306-.19Z",
    fill: "#3A3A3A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 10.5,
    y1: 0,
    x2: 6.412,
    y2: 18.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1F46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 10.5,
    y1: 3,
    x2: 10.5,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA65"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostIndicator);
export default __webpack_public_path__ + "static/media/host-indicator.f06357c3a616affb3e7a564eb00f0f911e8b7a4fa18c717afb6bc5c64c37e934.svg";
export { ForwardRef as ReactComponent };